import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const startCheckout = async (lookupKey, quantity = 1) => {
  try {
    const { data } = await axios.post(`${API}/payments/checkout`, {
      lookup_key: lookupKey,
      quantity,
      origin_url: window.location.origin,
    });
    window.location.href = data.checkout_url;
  } catch {
    toast.error("Paiement indisponible pour le moment. Appelez-nous au 06 18 90 74 35.");
  }
};
